import { useEffect, useState } from "react";

const useImage = (src) => {
  const [loaded, setloaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setloaded(true);
    };
  }, [src]);
  return loaded;
};

export default useImage;

// const {loaded} = useImage({src})
